import { z } from "zod";
/**
 * What the trainer is doing while a turn is still being written (`D191`).
 *
 * ── WHY A FRAME AT ALL ──────────────────────────────────────────────────────
 * `D19` holds every answer back until it is complete and validated, so a turn
 * that reads the plan, looks up two exercises and writes three lines shows the
 * person three dots for as long as all of that takes — now up to sixteen tool
 * steps (`MAX_TOOL_STEPS`). The answer still waits for validation; what this
 * adds is a line saying what is happening meanwhile ("Lendo o seu plano…"),
 * sent by the agent before each tool runs. It carries a CATEGORY and nothing
 * else: no tool input, no ids, no text a model wrote, so nothing unvalidated
 * reaches the screen.
 *
 * Not one of the SDK's `CHAT_FRAME` types — the drift test pins those against
 * the SDK's own bytes — so it has a prefix of its own, and a client that does
 * not know it falls through to the frame switch's `default` and ignores it.
 */
export const TRAINER_ACTIVITY_FRAME = "mypocketgym_trainer_activity";
export const TRAINER_ACTIVITIES = [
    "asking",
    "changing_plan",
    "logging",
    "reading_evidence",
    "reading_history",
    "reading_plan",
    "searching",
    "updating_profile",
];
export const trainerActivity = z.enum(TRAINER_ACTIVITIES);
export const trainerActivityFrame = z.object({
    activity: trainerActivity,
    type: z.literal(TRAINER_ACTIVITY_FRAME),
});
//# sourceMappingURL=activity.js.map